import useAuthTokens from "./useAuthTokens";

const useAccessToken = () => {
  const { data, ...rest } = useAuthTokens();

  return { accessToken: data?.accessToken, ...rest };
};

export default useAccessToken;
